
import HelloWorld from '@/components/HelloWorld'
import a00299303 from '../components/modules/00299303/00299303.vue'
import a00399302 from '../components/modules/00399302/00399302.vue'
import login from '../Login.vue'

export default[
    { name: '/', path: '/', redirect: '/login'},
    { name: 'login', path: '/login', component: login, meta: {  } },
    //{ name: 'home', path: '/home', component: home, meta: { requireAuth: true, } },
    { name: 'a00299303', path: '/a00299303', component: a00299303, meta: { requireAuth: true, } },
    { name: 'a00399302', path: '/a00399302', component: a00399302, meta: { requireAuth: true, } },
    {path: '/',name: 'Hello',component: HelloWorld}
  ]




// WEBPACK FOOTER //
// ./src/router/index.js